import type { AllRouteEndpoints } from "../routeTypes";

export const customObjectsUserLinkedCustomObjectTypes = "/custom_objects/user_linked_custom_object_types";

export const customObjectsUserLinkedCustomObjectTypesCacheKeys: AllRouteEndpoints[] = [
  "/custom_objects/user_linked_custom_object_types",
];
